import type { ViewStyle } from 'react-native'

export function getCssTransform(transform: ViewStyle['transform']): string | undefined {
  if (!Array.isArray(transform)) {
    return undefined
  }

  const values = transform.flatMap((item) => {
    if (typeof item !== 'object' || item === null) {
      return []
    }

    const transformEntry = item as Record<string, unknown>
    const transformKey = Object.keys(transformEntry)[0]

    if (!transformKey) {
      return []
    }

    const transformValue = transformEntry[transformKey]

    if (typeof transformValue !== 'number' && typeof transformValue !== 'string') {
      return []
    }

    const cssValue =
      typeof transformValue === 'number' && (transformKey === 'translateX' || transformKey === 'translateY')
        ? `${transformValue}px`
        : String(transformValue)

    return [`${transformKey}(${cssValue})`]
  })

  return values.length > 0 ? values.join(' ') : undefined
}
